import DateTime from './DateTime'

export default DateTime



// WEBPACK FOOTER //
// ./src/components/DateTime/index.js